<template>
    <div>
        <b-form-group label="Value"
                      label-size="sm"
                      :label-cols-sm="1"
                      description="Set value or FDO reference">
            <b-form-input size="sm"
                          v-model="value[0]"></b-form-input>
            <b-form-text id="input-live-help"></b-form-text>
        </b-form-group>
        <b-form-group label="Regular expression"
                      label-size="sm"
                      :label-cols-sm="1"
                      description="Example: /^[a-z]{3}$/i">
            <b-form-input size="sm" v-model="value[1]"></b-form-input>
        </b-form-group>
    </div>
</template>

<script>
import valueCmp from "./mixins/valueCmp";

export default {
    mixins: [valueCmp],
}
</script>

<style scoped>

</style>
